// função necessária para o Chakra UI funcionar em navegadores antigos (ex.: Chrome 67)
/*! fromentries. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */
function fromEntries(iterable) {
  return [...iterable].reduce((obj, [key, val]) => {
    obj[key] = val;
    return obj;
  }, {});
}

if (!Object.fromEntries) Object.fromEntries = fromEntries;
